import Model from "../model";
import { NormalizedModel } from "../utils/normalized/types";

export const ModelType = "GUEST";

export default class Guest extends Model {
  // Attributes
  segmentAnonymousId: string = "";

  constructor(attributes: { [key: string]: any }) {
    super();
    this.addAttributes(attributes);
  }

  deserialize(input: NormalizedModel) {
    this.id = input.id;
    this.addAttributes(input.attributes);
  }
}
